import React from 'react';
import { ScrollView, Text, View } from 'react-native-web';
import {
  Bill_1234567_January,
  Default_confirmation_screen,
  Dollar_79_29,
  Electricity_and_Co,
  Payment_date,
  Today_str,
} from '../../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../../FullPageSimulator';
import ParagraphWithSmallSubTitle from '../../../AuxiliaryComponent/TextComponent/ParagraphWithSmallSubTitle';
import LargeBtnWithFilling from '../../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';

//= ========================================================================
const PayBillsConfirmationFP = ({
  globJSON,
  subCategoryId,
  simPlatform,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { confirmation_bill } = globJSON.configurations.services[subCategoryId];

  const myStyles = {
    primaryTextStyle: {
      fontSize: 9.3,
      color: colors.primary_font_color,
    },
    secondaryTextStyle: {
      fontSize: 6.6,
      color: '#718096',
      paddingVertical: 2,
    },
    highlightedTextStyle: {
      color: colors.links_icons_color,
      fontSize: 10,
      lineHeight: 11.6,
      fontWeight: 'bold',
    },
    priceStyle: {
      fontSize: 19,
      fontWeight: 'bolder',
      color: colors.primary_font_color,
    },
    priceContainer: {
      width: 181,
      height: 1,
      borderWidth: 0.6,
      border: 'solid',
      marginVertical: 5,
      borderColor: colors.border_light_color,
    },
    scrollViewStyle: { alignSelf: 'center' },
    firstLineStyle: { width: 1, height: 5 },
    secondLineStyle: { width: 1, height: 10 },
    boxContainer: {

      width: 198,
      height: 127,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      backgroundColor: colors.light_elements_color,
      paddingVertical: 9,
      paddingHorizontal: 9,
    },

  };

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={confirmation_bill.does_it_look_ok}
      TopTitle={Default_confirmation_screen}
      slideshowRefs={slideshowRefs}
    >
      <ScrollView
        style={myStyles.scrollViewStyle}
        vertical
        pagingEnabled={false}
        showsVerticalScrollIndicator={false}
        scrollEnabled
      >
        <ParagraphWithSmallSubTitle
          globJSON={globJSON}
          simPlatform={simPlatform}
        />

        <View style={myStyles.firstLineStyle} />

        <View
          style={myStyles.boxContainer}
        >
          <Text style={myStyles.primaryTextStyle}>
            {Electricity_and_Co}
          </Text>
          <Text style={myStyles.secondaryTextStyle}>
            {Bill_1234567_January}
          </Text>

          <Text style={[myStyles.highlightedTextStyle, { paddingVertical: 4 }]}>
            {confirmation_bill.more_details}
          </Text>
          {confirmation_bill.allow_customer_to_change_payment_date
                    && (
                    <View>
                      <Text style={[myStyles.secondaryTextStyle, { marginTop: 3 }]}>
                        {Payment_date}
                      </Text>
                      <Text style={[myStyles.highlightedTextStyle, { paddingVertical: 1 }]}>
                        {Today_str}
                      </Text>
                    </View>
                    )}
          <View style={myStyles.priceContainer} />
          <Text style={myStyles.priceStyle}>
            {Dollar_79_29}
          </Text>
        </View>
        <LargeBtnWithFilling
          globJSON={globJSON}
          simPlatform={simPlatform}
          subCategoryId={subCategoryId}
          inputText={confirmation_bill.confirm_payment}
        />
        <View style={myStyles.secondLineStyle} />
      </ScrollView>
    </FullPageSimulator>

  );
};

export default PayBillsConfirmationFP;
